export const countNumberX = (number: string) => {
  return (number.match(/x/gi) || []).length;
};
